<template>
    <div class="hk" dir="rtl">
        <div class="hk-hero">
            <img src="../../static/img/hanuka2026.png" alt="חנוכה 2026 - אתם הגיבורים" class="hk-flyerImg" />
        </div>
        <div class="hk-page">

            <section class="hk-section hk-reveal">
                <h2>על מה מדובר?</h2>
                <p>
                    משחק ניווט סוחף שמכניס את השחקנים לתוך תקופת מרד החשמונאים נגד היוונים —
                    מבוסס על הסיפור האמיתי של מה שקרה אז. השחקנים עוברים ברגל מנקודה לנקודה
                    ביישוב שלכם, פותרים חידות, עונים על שאלות ומשחקים בפאזלים לאורך הדרך.
                </p>
                <p>
                    מתאים לקיבוץ, מושב או שכונה בעיר — פעילות קהילתית לכל המשפחה לרגל חנוכה.
                </p>
            </section>

            <section class="hk-priceSection hk-reveal">
                <div class="hk-priceCard">
                    <div class="hk-priceFeatures">
                        <div class="hk-priceFeature">👥 ללא הגבלת מספר משתתפים</div>
                        <div class="hk-priceFeature">📍 המשחק מגיע אליכם, ביישוב שלכם</div>
                        <div class="hk-priceFeature">⚡ מוכן תוך שעות ספורות, קל להקמה</div>
                        <div class="hk-priceFeature">🙌 מינימום מאמץ לפעילות קהילתית לכל המשפחה</div>
                    </div>
                    <div class="hk-priceFooter">
                        <span>מחיר לפעילות מלאה</span>
                        <span class="hk-priceValueSmall">2,400 ₪</span>
                    </div>
                </div>
            </section>

            <section class="hk-section hk-reveal">
                <h2>איך זה עובד?</h2>
                <p>
                    אתם בוחרים את הנקודות שבהן יעבור המסלול ביישוב שלכם, שולחים לנו תמונה
                    ומיקום GPS לכל נקודה — וזהו. אנחנו דואגים לכל השאר.
                </p>
                <router-link to="/howItWorks" class="hk-link">להסבר המלא על אופן הפעולה ←</router-link>
            </section>

            <section class="hk-contactSection hk-reveal">
                <h2>רוצים לדעת עוד?</h2>
                <p class="hk-contactIntro">השאירו פרטים ונחזור אליכם, או דברו איתנו ישירות בוואטסאפ.</p>

                <form class="hk-form" @submit.prevent="submitForm">
                    <input v-model="form.name" type="text" placeholder="שם מלא *" required />
                    <input v-model="form.phone" type="tel" placeholder="טלפון *" required />
                    <input v-model="form.email" type="email" placeholder="אימייל" />
                    <input v-model="form.settlement" type="text" placeholder="שם היישוב" />
                    <textarea v-model="form.message" placeholder="הודעה (אופציונלי)" rows="4"></textarea>
                    <button type="submit" class="hk-submitBtn" :disabled="sending">
                        {{ sending ? "שולח…" : "שליחה" }}
                    </button>
                    <div v-if="sent" class="hk-sentMsg">✅ הפנייה נשלחה, נחזור אליכם בקרוב!</div>
                    <div v-if="sendError" class="hk-errorMsg">❌ שגיאה בשליחה, נסו שוב או פנו בוואטסאפ.</div>
                </form>

                <a :href="whatsappLink" target="_blank" rel="noopener" class="hk-whatsappBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326M7.994 14.521a6.6 6.6 0 0 1-3.37-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.578 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.2-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.336-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                    דברו איתנו בוואטסאפ
                </a>
            </section>

            <footer class="hk-footer">
                <span>eifoany.web.app</span>
            </footer>

        </div>
    </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";

export default {
    data() {
        return {
            form: {
                name: "",
                phone: "",
                email: "",
                settlement: "",
                message: "",
            },
            sending: false,
            sent: false,
            sendError: false,
            whatsappNumber: "972526630434",
        };
    },
    mounted() {
        this.revealObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("hk-reveal--visible");
                        this.revealObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15 },
        );
        this.$el.querySelectorAll(".hk-reveal").forEach((el) => this.revealObserver.observe(el));
    },
    beforeUnmount() {
        if (this.revealObserver) this.revealObserver.disconnect();
    },
    computed: {
        whatsappLink() {
            const msg = `שלום, אני מעוניין/ת להזמין את משחק הניווט לחנוכה 2026`;
            return `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(msg)}`;
        },
    },
    methods: {
        async submitForm() {
            this.sending = true;
            this.sendError = false;
            try {
                await firebase.database().ref("leads/hanuka2026").push({
                    ...this.form,
                    createdAt: Date.now(),
                });
                this.sent = true;
                this.form = { name: "", phone: "", email: "", settlement: "", message: "" };
            } catch (e) {
                this.sendError = true;
            }
            this.sending = false;
        },
    },
};
</script>

<style scoped>
.hk {
    --bg: #14100c;
    --surface: #1f1813;
    --border: #3a2e22;
    --text: #f3ead9;
    --text-2: #c9b89c;
    --accent: #d9a441;
    --accent-dark: #8a5a1f;

    background: var(--bg);
    color: var(--text);
    font-family: 'VarelaRound', system-ui, sans-serif;

    width: 100vw;
    margin-inline: calc(50% - 50vw);
    min-height: 100vh;
    min-height: 100dvh;
    margin-bottom: -200px;
    padding-bottom: 200px;
    overflow-x: hidden;
}

.hk * {
    box-sizing: border-box;
}

.hk-page {
    max-width: 560px;
    margin: 0 auto;
    padding: 24px 20px 60px;
}

.hk-hero {
    max-width: 560px;
    margin: 0 auto;
}

.hk-flyerImg {
    display: block;
    width: 100%;
}

.hk-reveal {
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.7s ease, transform 0.7s ease;
}

.hk-reveal--visible {
    opacity: 1;
    transform: none;
}

.hk-section {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 22px;
    margin-bottom: 20px;
}

.hk-section h2 {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 12px;
    color: var(--accent);
}

.hk-section p {
    font-size: 15px;
    line-height: 1.7;
    color: var(--text-2);
    margin: 0 0 10px;
}

.hk-section p:last-child {
    margin-bottom: 0;
}

.hk-link {
    display: inline-block;
    margin-top: 6px;
    color: var(--accent);
    text-decoration: underline;
    font-size: 14px;
    font-weight: 600;
}

.hk-priceSection {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.hk-priceCard {
    background: linear-gradient(135deg, var(--accent-dark), var(--accent));
    border-radius: 16px;
    padding: 20px 24px;
    width: 100%;
    max-width: 420px;
}

.hk-priceFeatures {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
}

.hk-priceFeature {
    font-size: 14.5px;
    font-weight: 600;
    color: #1a1208;
    line-height: 1.4;
}

.hk-priceFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(26, 18, 8, 0.25);
    padding-top: 10px;
    font-size: 13px;
    color: #4a3012;
}

.hk-priceValueSmall {
    font-weight: 700;
    font-size: 14px;
    color: #1a1208;
}

.hk-contactSection {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 22px;
    margin-bottom: 20px;
    text-align: center;
}

.hk-contactSection h2 {
    font-size: 20px;
    font-weight: 700;
    color: var(--accent);
    margin: 0 0 8px;
}

.hk-contactIntro {
    font-size: 14px;
    color: var(--text-2);
    margin: 0 0 18px;
}

.hk-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 18px;
    text-align: right;
}

.hk-form input, .hk-form textarea {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 10px 12px;
    color: var(--text);
    font-family: inherit;
    font-size: 14px;
}

.hk-form input::placeholder, .hk-form textarea::placeholder {
    color: #8a7a62;
}

.hk-submitBtn {
    background: var(--accent);
    color: #1a1208;
    border: none;
    border-radius: 30px;
    padding: 12px;
    font-weight: 700;
    font-size: 15px;
    cursor: pointer;
    margin-top: 4px;
}

.hk-submitBtn:disabled {
    opacity: 0.6;
    cursor: default;
}

.hk-sentMsg {
    color: #8fd19e;
    font-size: 14px;
    text-align: center;
}

.hk-errorMsg {
    color: #e08b8b;
    font-size: 14px;
    text-align: center;
}

.hk-whatsappBtn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #25D366;
    color: white;
    text-decoration: none;
    font-weight: 700;
    font-size: 15px;
    padding: 12px 26px;
    border-radius: 30px;
}

.hk-footer {
    text-align: center;
    margin-top: 30px;
    font-size: 12px;
    color: var(--text-2);
}
</style>
